// extracted by mini-css-extract-plugin
export var active = "_mt-2";
export var recordingDot = "_mt-1";
export var recordingIndicator = "_mt-0";